<template>
  <div class="mr-2.5 flex items-center">
    <span class="text-xss text-main mr-1.5">Items per page</span>
    <div class="w-16">
      <SwdNativeSelect :options="actions" size="small" :init-value="initValue" @select="handleItemsPerPage" />
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'SwdItemsPerPage',
  props: {
    actionsItemsPerPage: {
      type: Array,
      required: false,
      default: () => [],
    },
    destination: {
      type: String,
      required: true,
      default: 'defaultItemsPerPage',
    },
  },
  emits: ['selectPage'],
  setup(props, { emit }) {
    const store = useStore()
    const route = useRoute()

    const initValue = ref(String(store.state.globalComponents.itemsPerPage.values[props.destination]))
    const actions = ref(store.state.globalComponents.itemsPerPage.options)

    const isPublicRoute = computed(() => route.meta?.publicRoute || false)

    const handleItemsPerPage = (command) => {
      const commandValue = String(command)
      const current = store.state.globalComponents.itemsPerPage.values[props.destination]

      if (commandValue !== current && !isPublicRoute.value) {
        store.commit('globalComponents/setDestinationItemsPerPage', {
          destination: props.destination,
          value: commandValue,
        })
        emit('selectPage', 1)
      }

      initValue.value = commandValue
    }

    return {
      handleItemsPerPage,
      initValue,
      actions,
    }
  },
}
</script>
